import React from 'react'

const OurPartners = () => {
  return (
    <div className='my-5'>
        <h1 className='text-center font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] lg:text-[35px] sm:text-[25px] text-[22px] mb-8'>Our Partners</h1>
      <img src={process.env.PUBLIC_URL +'/assets/partners.png'} className='max-w-[1300px] w-full mx-auto'/>
    </div>
  )
}

export default OurPartners
